import LabServiceModel from "@/models/LabServiceModel";

export default class ProjectStatusModel extends LabServiceModel {
  modelName() {
    return 'project-status';
  }
  defaults() {
    return {
      id: null,
      status: null,
      description: null,
      order: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      project_status_logs: [],
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      status: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      created_at: String,
      updated_at: String,
      deleted_at: String
    }
  }
  validation() {
    return {}
  }
  getIcon() {
    switch(this.status) {
      case 'Complete':
        return 'box-check';
      case 'In Progress':
        return 'box';
      case 'Open':
        return 'box-open';
      default:
        return 'shovel';
    }
  }
  getVariant() {
    switch(this.status) {
      case 'Complete':
        return 'success';
      case 'In Progress':
        return 'warning';
      case 'Open':
        return 'info';
      default:
        return 'dark';
    }
  }



}
